import React, { createElement } from 'react';

import { Space, Tag } from 'antd';

import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';


export function getIssueDerivedStatus(
    status: Issue.Model['status'],
    deadline: Issue.Model['deadline']
): { status: Issue.DerivedStatus; isOverdue: boolean } {
    const isOverdue =
        status !== 'closed' &&
        deadline !== null &&
        dayjs().isAfter(dayjs(deadline), 'day');

    return { status, isOverdue };
}

type DerivedStatusTag = {
    color: string;
    icon: React.ReactNode;
    text: string;
};

export function getIssueDerivedStatusTagProps(
    status: Issue.DerivedStatus,
    isOverdue: boolean
): DerivedStatusTag[] {
    const tags: DerivedStatusTag[] = [];

    if (status === 'closed') {
        tags.push({ color: 'success', icon: createElement(CheckCircleOutlined), text: 'Resolvido' });
    } else if (status === 'in_progress') {
        tags.push({ color: 'blue', icon: createElement(CheckCircleOutlined), text: 'Em andamento' });
    } else if (status === 'waiting_ogm') {
        tags.push({ color: 'yellow', icon: createElement(CheckCircleOutlined), text: 'Aguardando assembleia' });
    } else if (status === 'opened') {
        tags.push({ color: 'orange', icon: createElement(ClockCircleOutlined), text: 'Pendente' });
    }

    return tags;
}

export function getIssueDeadline(deadline: Issue.Model['deadline'], status: Issue.Model['status'])
{
    if (!deadline)
        return '-';

    const isOverdue = dayjs().isAfter(dayjs(deadline), 'day');
    const formattedDate = dayjs(deadline).format('DD/MM/YYYY');

    if (isOverdue && status !== 'closed')
        return <Space>{formattedDate} <Tag color='red' icon={<CloseCircleOutlined />} >Atrasado</Tag></Space>;

    return formattedDate;
}

export function getUserInitials(name: string): string {
    const [firstName, lastName] = name.toUpperCase().split(' ');
    const initials = lastName ? firstName[0] + lastName[0] : firstName[0];

    return initials;

}